/// <amd-module name="FeedTest/Utils/GlobalPermission" />
import { IGlobalPermissionData } from "Feed/Admin/Types";

import { createIdentity } from "./Identity";

export function makePermissions(everyoneIsCreator: boolean): IGlobalPermissionData {
    return {
        everyoneIsCreator,
        creatorIds: [createIdentity("creator")],
        adminIds: [createIdentity("admin")],
        customNames: ["somename"]
    } as IGlobalPermissionData;
}
